module.exports = __webpack_public_path__ + "d7c2ef87f26bc58c59e7c110e4c6f7e8.svg";